"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatelessSettingsModal = void 0;
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../context");
const ErrorBoundary_1 = require("../../ErrorBoundary");
const Modal_1 = tslib_1.__importDefault(require("../../../ui-lib/Modal"));
exports.StatelessSettingsModal = Modal_1.default;
const ModularModal = (0, mobx_react_lite_1.observer)(({ children, open, onCloseButtonClick, ...props }) => {
    const componentName = "<SettingsModal/>";
    const ctx = (0, react_1.useContext)(context_1.EncoderUiContext) != null
        ? (0, react_1.useContext)(context_1.EncoderUiContext)
        : (0, react_1.useContext)(context_1.PlayerUiContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, componentName);
    const toggleSettings = () => {
        ctx.viewSettings = !ctx.viewSettings;
    };
    const handleClick = (0, ErrorBoundary_1.useUIEventError)(toggleSettings, componentName);
    return (react_1.default.createElement(Modal_1.default, { ...props, open: open !== null && open !== void 0 ? open : ctx.viewSettings, onCloseButtonClick: onCloseButtonClick !== null && onCloseButtonClick !== void 0 ? onCloseButtonClick : handleClick, title: "Settings" }, children));
});
const ModalWithErrorBoundary = ({ children, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(Modal_1.default, { ...props }) },
        react_1.default.createElement(ModularModal, { ...props }, children)));
};
exports.default = ModalWithErrorBoundary;
//# sourceMappingURL=SettingsModal.js.map